import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VendorPermission } from '../core/models/entities/permission';
import { RatesPageComponent } from './pages/rates-page/rates-page.component';
import { SettingsPageComponent } from './pages/settings-page/settings-page.component';
import { CancelConditionsPageComponent } from './pages/cancel-conditions-page/cancel-conditions-page.component';
import { CommunicationTemplatesPageComponent } from './pages/communication-templates-page/communication-templates-page.component';
import { TestModePageComponent } from './pages/test-mode-page/test-mode-page.component';
import { AuthenticationSettingsPageComponent } from './pages/authentication-settings-page/authentication-settings-page.component';
import { CalendarConstraintsPageComponent } from './pages/calendar-constraints-page/calendar-constraints-page.component';
import { PaymentMethodsPageComponent } from './pages/payment-methods-page/payment-methods-page.component';
import { CustomFieldsPageComponent } from './pages/custom-fields-page/custom-fields-page.component';

const routes: Routes = [
  {
    path: '',
    component: SettingsPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'mode-test',
    component: TestModePageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'groupes-de-tarifs',
    component: RatesPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'modes-de-paiement',
    component: PaymentMethodsPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'conditions-annulation',
    component: CancelConditionsPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'ouverture-calendrier',
    component: CalendarConstraintsPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'modeles-communication',
    component: CommunicationTemplatesPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'securite',
    component: AuthenticationSettingsPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.Update,
    },
  },
  {
    path: 'champs-personnalises',
    component: CustomFieldsPageComponent,
    data: {
      manager: true,
      requiredPermission: VendorPermission.ViewAny,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
